import { registerLocaleData } from '@angular/common'

import localeEn from '@angular/common/locales/en'
import localeDa from '@angular/common/locales/da'
import localeFi from '@angular/common/locales/fi'
import localeNo from '@angular/common/locales/no'
import localePl from '@angular/common/locales/pl'
import localeSk from '@angular/common/locales/sk'
import localeSv from '@angular/common/locales/sv'
import localeUk from '@angular/common/locales/uk'
import localeRo from '@angular/common/locales/ro'

export const registerAngularLocales = () => {
  registerLocaleData(localeEn, 'en')
  registerLocaleData(localeDa, 'da')
  registerLocaleData(localeFi, 'fi')
  registerLocaleData(localeNo, 'no')
  registerLocaleData(localePl, 'pl')
  registerLocaleData(localeSk, 'sk')
  registerLocaleData(localeSv, 'sv')
  registerLocaleData(localeUk, 'uk')
  registerLocaleData(localeRo, 'ro')
}
